import {
  ExternalLinkIcon,
  InfoIcon,
  LockIcon,
  SearchIcon,
} from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";

// Mirrors the mobile ComicActionButton: the label, icon and emphasis of the
// primary read action all follow the type of link we hold for the issue.
const getColorScheme = (urlType) => {
  switch (urlType) {
    case "dcui":
    case "dcfandom":
      return "blue";
    case "google":
      return "gray";
    default:
      return "red";
  }
};

const getIcon = (urlType) => {
  switch (urlType) {
    case "marvel":
    case "dcui":
      return <ExternalLinkIcon />;
    case "dcfandom":
      return <InfoIcon />;
    case "google":
      return <SearchIcon />;
    default:
      return <ExternalLinkIcon />;
  }
};

const getVariant = (urlType) => {
  switch (urlType) {
    case "dcfandom":
    case "google":
      return "outline";
    default:
      return "solid";
  }
};

const getContent = (urlType) => {
  switch (urlType) {
    case "marvel":
      return "Read on MU";
    case "dcui":
      return "Read on DCUI";
    default:
      return "Look up";
  }
};

// Chakra's `blue` scale is remapped to the brand red in redwing-theme, so the
// DC Universe Infinite link uses the palette's info blue explicitly.
const infoBlueProps = {
  bg: "#0371f0",
  color: "white",
  _hover: { bg: "#0261cf" },
  _active: { bg: "#0355b3" },
};

const ComicActionButton = ({ urlType, content, isDisabled, ...props }) => {
  const variant = getVariant(urlType);
  const colorProps =
    urlType === "dcui" && variant === "solid" ? infoBlueProps : {};

  return (
    <Button
      colorScheme={getColorScheme(urlType)}
      variant={variant}
      color={variant === "solid" ? "white" : undefined}
      isDisabled={isDisabled}
      leftIcon={isDisabled ? <LockIcon /> : getIcon(urlType)}
      {...colorProps}
      {...props}
    >
      {content || getContent(urlType)}
    </Button>
  );
};

export default ComicActionButton;
